export const pilingMachineDefaultValues = {};
